export default {
  not_started: 'Configure a sua conta de pagamento — a sua partilha de receita fica em espera até ser verificada.',
  bank_account_missing:
    'Adicione uma conta bancária para pagamentos — a sua partilha de receita fica em espera até o fazer.',
  incomplete:
    'A sua conta de pagamento ainda não está totalmente verificada — a sua partilha de receita fica em espera até que esteja.',
  add_bank_account: 'Adicionar conta bancária',
  cta: 'Concluir configuração',
};
